import { Col, Row } from "react-bootstrap";
import { CgCPlusPlus } from "react-icons/cg";
import { DiJava, DiJavascript1, DiMongodb, DiNodejs, DiPython, DiReact } from "react-icons/di";
import { FaServer } from "react-icons/fa";
import {
  SiDocker,
  SiElasticsearch,
  SiGithubactions,
  SiJest,
  SiMui,
  SiMysql,
  SiNextdotjs,
  SiPostgresql,
  SiRedis,
  SiRedux,
  SiLeetcode,
  SiSpringboot,
  SiStorybook,
  SiTypescript,
} from "react-icons/si";

const skillGroups = [
  {
    title: "Full-Stack Engineering",
    summary: "End-to-end product development across frontend, backend, APIs, and data workflows.",
    skills: [
      { name: "React", icon: <DiReact /> },
      { name: "Node.js", icon: <DiNodejs /> },
      { name: "Spring Boot", icon: <SiSpringboot /> },
      { name: "TypeScript", icon: <SiTypescript /> },
      { name: "JavaScript", icon: <DiJavascript1 /> },
      { name: "REST APIs", icon: <FaServer /> },
    ],
  },
  {
    title: "Backend & APIs",
    summary: "Service logic, integrations, authentication, and production-ready backend systems.",
    skills: [
      { name: "Java", icon: <DiJava /> },
      { name: "Spring Boot", icon: <SiSpringboot /> },
      { name: "Node.js", icon: <DiNodejs /> },
      { name: "Python", icon: <DiPython /> },
      { name: "C++", icon: <CgCPlusPlus /> },
      { name: "API Design", icon: <FaServer /> },
    ],
  },
  {
    title: "Data, Search & Storage",
    summary: "Database-backed applications, search systems, caching, and data access patterns.",
    skills: [
      { name: "PostgreSQL", icon: <SiPostgresql /> },
      { name: "MongoDB", icon: <DiMongodb /> },
      { name: "Elasticsearch", icon: <SiElasticsearch /> },
      { name: "MySQL", icon: <SiMysql /> },
      { name: "Redis", icon: <SiRedis /> },
    ],
  },
  {
    title: "DSA & System Design",
    summary: "Strong algorithmic foundation and interest in scalable system design.",
    skills: [
      { name: "500+ LeetCode", icon: <SiLeetcode /> },
      { name: "DSA", icon: <FaServer /> },
      { name: "System Design", icon: <FaServer /> },
      { name: "Algorithms", icon: <CgCPlusPlus /> },
    ],
  },
  {
    title: "Delivery & Frontend Depth",
    summary: "Testing, CI/CD, containers, and polished interfaces for complete delivery.",
    skills: [
      { name: "Docker", icon: <SiDocker /> },
      { name: "GitHub Actions", icon: <SiGithubactions /> },
      { name: "Jest", icon: <SiJest /> },
      { name: "Next.js", icon: <SiNextdotjs /> },
      { name: "Redux", icon: <SiRedux /> },
      { name: "Material UI", icon: <SiMui /> },
      { name: "Storybook", icon: <SiStorybook /> },
      { name: "JavaScript", icon: <DiJavascript1 /> },
    ],
  },
];

function Techstack() {
  return (
    <Row className="skill-showcase" style={{ justifyContent: "center", paddingBottom: "50px" }}>
      {skillGroups.map((group) => (
        <Col xs={12} md={6} lg={4} className="skill-panel-col" key={group.title}>
          <div className="skill-panel">
            <div className="skill-panel-header">
              <h3>{group.title}</h3>
              <p>{group.summary}</p>
            </div>
            <div className="skill-pill-grid">
              {group.skills.map((skill) => (
                <span className="skill-pill" key={`${group.title}-${skill.name}`}>
                  {skill.icon}
                  {skill.name}
                </span>
              ))}
            </div>
          </div>
        </Col>
      ))}
    </Row>
  );
}

export default Techstack;
